module Client.Style

open Fable.React.Props
open Fable.Core.JsInterop
open Fable.React
open Pages
open Elmish.React

let fa str = i [ ClassName ("fa fa-" + str) ] []
let glyph str = i [ ClassName ("glyphicon glyphicon-" + str) ] []
let jsVoid = Href "javascript:void(0)"

let panelWithTitleContent panelClass title content =
    div [ ClassName ("panel panel-" + panelClass) ] [
        div [ ClassName "panel-heading" ] [
            h3 [ ClassName "panel-title" ] title
        ]
        div [ ClassName "panel-body" ] content
    ]

let panel panelClass title content =
    panelWithTitleContent panelClass [ str title ] content

let modal title dispatch closeAction contents buttons =
    [
        div [
                ClassName "modal-backdrop in"
                Keyboard.onEscape closeAction dispatch
            ] []
        div [ 
                ClassName "modal in" 
                TabIndex -1
                Role "dialog"
                Style [
                    Display  DisplayOptions.Block
                ]
                Keyboard.onEscape closeAction dispatch
            ] [
                div [ 
                    ClassName "modal-dialog" 
                    Role "document"
                ] [ 
                    div [ ClassName "modal-content" ] [
                        yield div [ ClassName "modal-header" ] [
                            button [ 
                                Type "button"
                                ClassName "close"
                                Data ("dismiss","modal")
                                OnClick (fun e -> dispatch closeAction)      
                            ] [
                                span [] [ str "x" ]
                            ]
                            h4 [ ClassName "modal-title" ] [ str title ]
                        ]
                        yield div [ ClassName "modal-body" ] contents
                        if buttons |> List.isEmpty = false then
                            yield div [ ClassName "modal-footer" ] buttons
                    ]
                ]
            ]
    ]
                       
let inlineForm elements =
    div [
        ClassName "form-inline"
        Role "form"
    ] elements

let col_md_6 elements =
     div [ ClassName "col-md-6" ] elements

let formGroup elements =
    div [
        ClassName "form-group"
    ] elements

let formGroupWithErrors hasError elements =
    div [
        ClassName ("form-group" + if hasError then " has-error" else "")
    ] elements

let container elements =
    div [
        ClassName "container"
    ] elements

let fluidContainer elements =
    div [
        ClassName "container-fluid"
    ] elements

let defaultButton text =
    button [
        Type "button"
        ClassName "btn btn-default"
    ] [ str text ]

let viewLink page description =
  a [ 
        Style [ Padding "0 20px" ]
        Href (toHash page) 
    ] [ 
        str description
    ]

let centerStyle direction =
    Style [ 
        Display DisplayOptions.Flex
        FlexDirection direction
        AlignItems AlignItemsOptions.Center
        JustifyContent "center"
        Padding "20px 0"
    ]
open Fable.Import
open Fable.React.Props

let textInput id placeholder onChangeMsg dispatch (value: string) maxLength = 
    input [ 
        Type "text"
        ClassName "form-control"
        Id id
        Placeholder placeholder
        OnChange (fun ev -> dispatch (onChangeMsg !!ev.target?value) )
        Helpers.valueOrDefault value
        MaxLength (match maxLength with Some x -> x | _ -> 0.)
    ]

let dateInput id placeholder dispatch (value: string) = 
    input [ 
        Type "date"
        ClassName "form-control"
        Id id
        OnChange dispatch
        DefaultValue value 
    ]

let buttonLink cssClass onClick elements = 
    a [ 
        ClassName cssClass
        OnClick (fun _ -> onClick())
        OnTouchStart (fun _ -> onClick())
        Style [ 
            Cursor "pointer"
        ] 
    ] elements

let renderAttribution dispatch hider =
    modal "Licenses and Attribution" dispatch hider [
        p [] [ str "As with most companies, we make extensive use of open-source libraries to speed up development. Some libraries require you to
        credit them, and in some cases we want to show our appreciation by promoting awareness of them." ]
        ul [ ClassName "list-group" ] [
            li [ ClassName "list-group-item" ] [ 
                a [ Href "https://www.flickcom/photos/jerrylai0208/7985623795" ] [ str "Background image" ]
                str " licensed under "
                a [ Href "https://creativecommons.org/licenses/by-sa/2.0/" ] [ str "CC BY-SA 2.0" ]
                str ". The image was cropped to focus on the sky."
            ] 
            li [ ClassName "list-group-item" ] [ 
                a [ Href "https://getbootstrap.com/docs/3.3/" ] [ str "Bootstrap" ]
                str " is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web. It is licensed under "
                a [ Href "https://opensource.org/licenses/MIT" ] [ str "The MIT License" ]
            ] 
            li [ ClassName "list-group-item" ] [ 
                str "We proudly use the "
                a [ Href "https://safe-stack.github.io/" ] [ str "Safe Stack" ]
                str ", an open-source functional programming stack for web development."
            ]                     
        ]
    ] []

let siteFooter loginClick licenseClick =
    footer [ ClassName "footer" ] [
        div [ ClassName "container" ] [
            section [] [
                div [ ClassName "col-md-6 centerflex between" ] [
                    img [ Src "images/logo-home.png" ]
                    span [] [ str "(C) ILLY Systems 2018-2019" ]
                ]
                div [ ClassName "col-md-6 centerflex between" ] [
                    span [] [ str "Web: "; a [ Href "https://www.illycorp.com" ] [ str "www.illycorp.com" ]]
                    span [] [ str "Tweet: "; a [ Href "https://twittecom/ILLYSystems" ] [ str "@ILLYSystems" ]]
                ]
            ]
            section [] [
                div [ ClassName "col-md-6 centerflex between" ] [
                    a [ Href "public/privacy-policy.pdf" ] [ str "Privacy Policy" ]
                ]
                div [ ClassName "col-md-6 centerflex between" ] [
                    yield a [ jsVoid; OnClick licenseClick ] [ str "Licences and attribution" ]   
                    match loginClick with
                    | None -> ()
                    | Some click ->
                        yield a [
                            Href "#home"
                            OnClick click
                        ] [ str "Admin Login" ]    
                ]
            ]
        ]
    ]


